<template>
    <!-- <div class="the-empty">
      <img class="img-view" alt="" src="@/assets/images/person/Nulldata.png">
      <slot></slot>
      <p class="p-view" v-if="text">{{ text }}</p>
    </div> -->
    <div class="notFound">
        <div class="not-pic"></div>
        <div class="not-title">{{text}}</div>
    </div>
</template>

<script>
export default {
    name: "emptyPage",
    props: {
        text: {
            type: String,
            default: "暂无数据"
        }
    }
}
</script>

<style scoped lang="scss">
.notFound {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 80px;
    .not-pic {
        width: 261px;
        height: 282px;
        margin-top: 20px;
        background-image: url('../../assets/imgs/noData.png');
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }
    .not-title {
        font-size: 20px;
        font-weight: 500;
        color: #323232;
        line-height: 24px;
        margin: 30px 0;
    }
}
</style>